import React from 'react';
import { FireUiAnalytics, type Attributes } from '@atlassian/jira-product-analytics-bridge';

type Props = {
	attributes: Attributes;
};

export const ImportWorkButtonViewed = ({ attributes }: Props) => (
	<FireUiAnalytics
		action="viewed"
		actionSubject="button"
		actionSubjectId="importWorkButton"
		attributes={attributes}
	/>
);
